// iSQROLL Tui Icons
// 10 general icons available to all users + 20 reward icons unlocked through milestones

export interface TuiIcon {
  id: string
  path: string
  tier: 'general' | 'earned'
  earnedLabel?: string
}

// ── General Icons (available to all users) ──────────────────────────────────

export const TUI_ICONS: TuiIcon[] = [
  { id: 'tui-icon-1', path: '/images/tui-icons/tui-icon-1.png', tier: 'general' },
  { id: 'tui-icon-2', path: '/images/tui-icons/tui-icon-2.png', tier: 'general' },
  { id: 'tui-icon-3', path: '/images/tui-icons/tui-icon-3.png', tier: 'general' },
  { id: 'tui-icon-4', path: '/images/tui-icons/tui-icon-4.png', tier: 'general' },
  { id: 'tui-icon-5', path: '/images/tui-icons/tui-icon-5.png', tier: 'general' },
  { id: 'tui-icon-6', path: '/images/tui-icons/tui-icon-6.png', tier: 'general' },
  { id: 'tui-icon-7', path: '/images/tui-icons/tui-icon-7.png', tier: 'general' },
  { id: 'tui-icon-8', path: '/images/tui-icons/tui-icon-8.png', tier: 'general' },
  { id: 'tui-icon-9', path: '/images/tui-icons/tui-icon-9.png', tier: 'general' },
  { id: 'tui-icon-10', path: '/images/tui-icons/tui-icon-10.png', tier: 'general' },
]

// ── Reward Icons (unlocked through gamification milestones) ─────────────────

export const TUI_REWARD_ICONS: TuiIcon[] = [
  { id: 'tui-reward-1', path: '/images/tui-rewards/tui-reward-1.png', tier: 'earned' },
  { id: 'tui-reward-2', path: '/images/tui-rewards/tui-reward-2.png', tier: 'earned' },
  { id: 'tui-reward-3', path: '/images/tui-rewards/tui-reward-3.png', tier: 'earned' },
  { id: 'tui-reward-4', path: '/images/tui-rewards/tui-reward-4.png', tier: 'earned' },
  { id: 'tui-reward-5', path: '/images/tui-rewards/tui-reward-5.png', tier: 'earned' },
  { id: 'tui-reward-6', path: '/images/tui-rewards/tui-reward-6.png', tier: 'earned' },
  { id: 'tui-reward-7', path: '/images/tui-rewards/tui-reward-7.png', tier: 'earned' },
  { id: 'tui-reward-8', path: '/images/tui-rewards/tui-reward-8.png', tier: 'earned' },
  { id: 'tui-reward-9', path: '/images/tui-rewards/tui-reward-9.png', tier: 'earned' },
  { id: 'tui-reward-10', path: '/images/tui-rewards/tui-reward-10.png', tier: 'earned' },
  { id: 'tui-reward-11', path: '/images/tui-rewards/tui-reward-11.png', tier: 'earned' },
  { id: 'tui-reward-12', path: '/images/tui-rewards/tui-reward-12.png', tier: 'earned' },
  { id: 'tui-reward-13', path: '/images/tui-rewards/tui-reward-13.png', tier: 'earned' },
  { id: 'tui-reward-14', path: '/images/tui-rewards/tui-reward-14.png', tier: 'earned' },
  { id: 'tui-reward-15', path: '/images/tui-rewards/tui-reward-15.png', tier: 'earned' },
  { id: 'tui-reward-16', path: '/images/tui-rewards/tui-reward-16.png', tier: 'earned' },
  { id: 'tui-reward-17', path: '/images/tui-rewards/tui-reward-17.png', tier: 'earned' },
  { id: 'tui-reward-18', path: '/images/tui-rewards/tui-reward-18.png', tier: 'earned' },
  { id: 'tui-reward-19', path: '/images/tui-rewards/tui-reward-19.png', tier: 'earned' },
  { id: 'tui-reward-20', path: '/images/tui-rewards/tui-reward-20.png', tier: 'earned' },
]

export const DEFAULT_TUI_ICON = TUI_ICONS[0]

/** Get a Tui icon by its ID — searches both general and reward arrays */
export function getTuiIconById(id: string): TuiIcon | undefined {
  return TUI_ICONS.find((icon) => icon.id === id)
    ?? TUI_REWARD_ICONS.find((icon) => icon.id === id)
}

/** Get icons available to general users (excluding earned) */
export function getGeneralIcons(): TuiIcon[] {
  return TUI_ICONS
}

/** Get earned/reward icons */
export function getEarnedIcons(): TuiIcon[] {
  return TUI_REWARD_ICONS
}
